import { render, staticRenderFns } from "./InjectionRateTable.vue?vue&type=template&id=26245de8"
import script from "./InjectionRateTable.vue?vue&type=script&lang=ts"
export * from "./InjectionRateTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports